import React from "react";
import { Trans } from "react-i18next";
import "../styles/components/MessageBox.scss";

const MessageBox = (props: any) => {
  return (
    <div className="message-box bg-light-gray mb-4">
      <div className="text-center">
        <img src="/icons/no-data-icon.svg" />
        <span className="ps-2 d-inline-block align-middle">
          <Trans i18nKey={props.message_key}></Trans>
        </span>
      </div>
    </div>
  );
};

export default MessageBox;
